<template>
  <RF-Dialog
    :cpntLargura='"600px"'
    :cpntStatus="statusGeral"
    :cpntOnFecharDialog='cpntOnFecharDialog'>
    <template slot='titulo'>      
      <div class="dem-nova-titulo">
        <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
        <template v-if="cpntTipo === 'venda'">
          Número de Vendas por Cliente	
        </template>
        <template v-else>
          Quantidades por item	
        </template>
      </div>
    </template>

    <template slot='conteudo'>
      <div class="con-pro-painel-detalhe">
        <App-Tabela
        :cpntStatus="statusGeral"
        :cpntColuna="colunas"
        :cpntLinha="linhas"
        ref="tabela">
          <template v-slot:col_nome="{ linha }">
            <App-Button v-if="cpntTipo === 'venda'" :cpntClass="[ 'btn', 'btn-default', 'bt-link-cadastro' ]" @onClick='() => { conProPainelDetalheAbrirCadastro("contato", linha.id_con) }'>
              <!-- COLOCA O NOME DO CONTATO -->
              <span v-html="linha.id_con_nome"></span>

              <!-- VERIFICA SE É UMA PJ E SE TEM NOME FANTASIA -->
              <span v-if='linha.id_con_pessoa === "j" && linha.id_con_empresa !== ""' v-html="' (' + linha.id_con_empresa + ')'"></span>

              <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
              <b v-if='linha.id_con_status !== "1"' v-html="'[Excluído]'"></b>
            </App-Button>

            <App-Button v-else-if="cpntTipo === 'produto'" :cpntClass="[ 'btn', 'btn-default', 'bt-link-cadastro' ]" @onClick='() => { conProPainelDetalheAbrirCadastro("produto", linha.id) }'>
              <!-- COLOCA O NOME DO CONTATO -->
              <span v-html="linha.id_pro_nome"></span>

              <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
              <b v-if='linha.id_pro_status !== "1"' v-html="'[Excluído]'"></b>
            </App-Button>

            <App-Button v-else-if="cpntTipo === 'servico'" :cpntClass="[ 'btn', 'btn-default', 'bt-link-cadastro' ]" @onClick='() => { conProPainelDetalheAbrirCadastro("servico", linha.id) }'>
              <!-- COLOCA O NOME DO CONTATO -->
              <span v-html="linha.id_ser_nome"></span>

              <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
              <b v-if='linha.id_ser_status !== "1"' v-html="'[Excluído]'"></b>
            </App-Button>
          </template>
        </App-Tabela>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntTipo: {
        required: true,
        type: String
      },
      cpntDados: {
        required: true,
        type: Array
      },

      cpntOnFecharDialog: {
        required: true
      },
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        colunas: [],
        linhas: []
      }
    },
    mounted: function () {
      this.conProPainelDetalheIniciar()
    },
    methods: {
      conProPainelDetalheSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      conProPainelDetalheIniciar: function () {
        // SETA O STATUS GERAL DA PAGINA
        this.conProPainelDetalheSetarStatusGeral('carregando')

        // SETA AS INFORMAÇÕES PARA TABELA
        this.colunas = [
          { mPer: 2,   chave: 'id',     nome: 'Cód.'         },
          { mPer: 2,   chave: 'nome',   nome: 'Nome'         },
          { mPer: 2,   chave: 'qtde',   nome: 'Quantidade'   }
        ]

        // INICIA O VETOR 
        this.linhas = {}
        var linha = {}
        var indexV = ''
        var indexI = ''

        // VERIFICA O TIPO DE REGISTRO QUE DEVE USAR
        switch (this.cpntTipo) {
          case 'venda':
            for (indexV in this.cpntDados) {
              // LIMPA A VARIAVEL
              linha = {}

              // ADICIONA O ID
              linha.id = this.cpntDados[indexV].cod_venda_id_con

              // VERIFICA SE O VALOR EXITE NO VETOR
              if (this.linhas[linha.id] === undefined) {
                // INICIA A VARIAVEL DE QUANTIDADE
                linha.qtde = 1

                // SETA OS DADOS PARA O NOME DO CONTATO
                linha.id_con_cnpj_cpf = this.cpntDados[indexV].cod_venda_id_con_cnpj_cpf
                linha.id_con_empresa  = this.cpntDados[indexV].cod_venda_id_con_empresa
                linha.id_con_nome     = this.cpntDados[indexV].cod_venda_id_con_nome
                linha.id_con_pessoa   = this.cpntDados[indexV].cod_venda_id_con_pessoa
                linha.id_con_status   = this.cpntDados[indexV].cod_venda_id_con_status

                // ADICIONA A LINHA NO VETOR
                this.linhas[linha.id] = JSON.parse(JSON.stringify(linha))
              } else {
                this.linhas[linha.id].qtde = Number(this.linhas[linha.id].qtde) + 1
              }
            }
            break

            case 'produto':
              for (indexV in this.cpntDados) {
                if ([ '', null, undefined ].indexOf(this.cpntDados[indexV].itens) === -1 && this.cpntDados[indexV].itens.length >= 1) {
                  for (indexI in this.cpntDados[indexV].itens) {
                    if ([ '', null, undefined ].indexOf(this.cpntDados[indexV].itens[indexI].id_ven_pro) === -1) {
                      // LIMPA A VARIAVEL
                      linha = {}
      
                      // ADICIONA O ID
                      linha.id = this.cpntDados[indexV].itens[indexI].id_ven_pro_id_pro
      
                      // VERIFICA SE O VALOR EXITE NO VETOR
                      if (this.linhas[linha.id] === undefined) {
                        // INICIA A VARIAVEL DE QUANTIDADE
                        linha.qtde = 1
      
                        // SETA OS DADOS PARA O NOME DO CONTATO
                        linha.id_pro_nome     = this.cpntDados[indexV].itens[indexI].id_ven_pro_id_pro_nome
                        linha.id_pro_status   = this.cpntDados[indexV].itens[indexI].id_ven_pro_id_pro_status
      
                        // ADICIONA A LINHA NO VETOR
                        this.linhas[linha.id] = JSON.parse(JSON.stringify(linha))
                      } else {
                        this.linhas[linha.id].qtde = Number(this.linhas[linha.id].qtde) + 1
                      }
                    }
                  }
                }
              }
              break

            case 'servico':
              for (indexV in this.cpntDados) {
                if ([ '', null, undefined ].indexOf(this.cpntDados[indexV].itens) === -1 && this.cpntDados[indexV].itens.length >= 1) {
                  for (indexI in this.cpntDados[indexV].itens) {
                    if ([ '', null, undefined ].indexOf(this.cpntDados[indexV].itens[indexI].id_ven_ser) === -1) {
                      // LIMPA A VARIAVEL
                      linha = {}
      
                      // ADICIONA O ID
                      linha.id = this.cpntDados[indexV].itens[indexI].id_ven_ser_id_ser
      
                      // VERIFICA SE O VALOR EXITE NO VETOR
                      if (this.linhas[linha.id] === undefined) {
                        // INICIA A VARIAVEL DE QUANTIDADE
                        linha.qtde = 1
      
                        // SETA OS DADOS PARA O NOME DO CONTATO
                        linha.id_ser_nome     = this.cpntDados[indexV].itens[indexI].id_ven_ser_id_ser_nome
                        linha.id_ser_status   = this.cpntDados[indexV].itens[indexI].id_ven_ser_id_ser_status
      
                        // ADICIONA A LINHA NO VETOR
                        this.linhas[linha.id] = JSON.parse(JSON.stringify(linha))
                      } else {
                        this.linhas[linha.id].qtde = Number(this.linhas[linha.id].qtde) + 1
                      }
                    }
                  }
                }
              }
              break
        }

        // PEGA OS DADOS
        this.linhas = Object.values(this.linhas)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA O STATUS GERAL DA PAGINA
        this.conProPainelDetalheSetarStatusGeral('')
      },
      conProPainelDetalheAbrirCadastro: function (tipo, id) {
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, [ 12 ], null, [ 78 ], 'or', false) === true) {
          // SETA OS PARAMETROS QUE SERÁ ENVIADO
          var params = { editar: false, tipo: tipo, id: id }

          // SETA O CALLBACK QUE DEVE EXECUTAR
          params.callback = (atualizar) => {
            if (atualizar === true) {
              this.conProPainelDetalheIniciar()
            }
          }

          // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
          this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
        }
      },
    }
  }
</script>
